var exports = {
  "w": "TimeoutMemberSheet.module__header___UEw2al",
  "h": "TimeoutMemberSheet.module__description___UEw2al",
};

module.exports = exports;
